import { PageOptions } from './../../app/shared/data-table/data-table.interface';
import { BaseHttpService } from './../../app/shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { config } from '../../config/config';
import { getEnv } from '../utility';


@Injectable()
export class SpanMaintenanceApiService {
   constructor(
      private readonly http: BaseHttpService
   ) { }

   public getSpans(pageOptions?: PageOptions) {
      pageOptions = pageOptions || {
         page: 0,
         size: 10,
         order: 'asc',
         sort: 'span',
      };

      return this.http
         .get(`${config.tprecmApiBaseUrl[getEnv()]}maint/span?`
            + `page=${pageOptions.page}&sort=${pageOptions.sort}&order=${pageOptions.order}&size=${pageOptions.size}`);
   }

   public saveSpan(span) {
      return this.http
         .put(`${config.tprecmApiBaseUrl[getEnv()]}maint/span`, span);
   }

   public createSpan(span) {
      return this.http
         .post(`${config.tprecmApiBaseUrl[getEnv()]}maint/span`, span);
   }

   public deleteSpan(id) {
      return this.http
         .delete(`${config.tprecmApiBaseUrl[getEnv()]}maint/span/${id}`);
   }
}
